"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultRegistry = exports.CollectorRegistry = void 0;
var utils_1 = require("./utils");
var CollectorRegistry = (function () {
    function CollectorRegistry() {
        this.collectors = {};
        this.defaultLabelMap = {};
    }
    CollectorRegistry.prototype.register = function (collector) {
        if (this.collectors[collector.name]) {
            throw new Error("Collector already registered: ".concat(collector.name));
        }
        this.collectors[collector.name] = collector;
    };
    CollectorRegistry.prototype.unregister = function (name) {
        if (this.collectors[name]) {
            delete this.collectors[name];
        }
    };
    CollectorRegistry.prototype.setDefaultLabels = function (labelMap) {
        this.defaultLabelMap = labelMap;
    };
    CollectorRegistry.prototype.expose = function () {
        var collectors = Object.values(this.collectors);
        var defaultLabelNames = Object.keys(this.defaultLabelMap);
        var results = [];
        for (var _i = 0, collectors_1 = collectors; _i < collectors_1.length; _i++) {
            var collector = collectors_1[_i];
            var samples = collector.collect();
            if (samples.length > 0) {
                var help = "# HELP ".concat(collector.name, " ").concat(collector.help, "\n");
                var type = "# TYPE ".concat(collector.name, " ").concat(collector.type, "\n");
                if (defaultLabelNames.length > 0) {
                    for (var _a = 0, samples_1 = samples; _a < samples_1.length; _a++) {
                        var sample = samples_1[_a];
                        sample.labels = __assign(__assign({}, this.defaultLabelMap), sample.labels);
                    }
                }
                results.push(help, type);
                results.push.apply(results, (0, utils_1.convertSamplesToText)(samples));
            }
        }
        return results.join('');
    };
    CollectorRegistry.prototype.reset = function () {
        this.collectors = {};
        this.defaultLabelMap = {};
    };
    return CollectorRegistry;
}());
exports.CollectorRegistry = CollectorRegistry;
exports.defaultRegistry = new CollectorRegistry();
//# sourceMappingURL=CollectorRegistry.js.map